import {CREATE_AC_SUCCESS, FETCH_ACTIVITY_SNO_SUCCESS_FOR_ACTIVITY_CLOSURE,} from "../../constants/ActionTypes";

const INIT_STATE = {
  resource: {},
  activitySno: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_AC_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ACTIVITY_SNO_SUCCESS_FOR_ACTIVITY_CLOSURE: {
      return {
        ...state,
        activitySno: action.data,
      }
    }
    default:
      return state;
  }
}
